import type {
  SingleValueGridRequiredProps,
  SingleValueGridSparklineRequiredProps,
  SingleValueGridTrendRequiredProps,
} from './types/single-value-grid.js';

export const sparklineDefaultProps: SingleValueGridSparklineRequiredProps = {
  showTicks: false,
  showContextValues: false,
  variant: 'line',
  curve: 'linear',
  gapPolicy: 'connect',
};

export const trendDefaultProps: SingleValueGridTrendRequiredProps = {
  showIcon: true,
  inverseTrend: 'none',
};

export const gridDefaultProps: SingleValueGridRequiredProps = {
  alignment: 'start',
  applyThresholdBackground: false,
};

export const SINGLE_VALUE_GRID_ARIA_LABEL = 'Single Value Grid';
